import { Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JournalModel } from '@ov-suite/models-warehouse';
import { ManualJournalModalComponent } from '../manual-journal-modal/manual-journal-modal.component';

@Component({
  selector: 'ov-suite-journal-events-list',
  templateUrl: './journal-events-list.component.html',
})
export class JournalEventsListComponent {
  formClass = JournalModel;

  @ViewChild('journalTable') journalTable?: { refresh: (refresh: boolean) => void };

  constructor(private readonly modalService: NgbModal) {}

  onAdd() {
    const modalRef = this.modalService.open(ManualJournalModalComponent, { size: 'lg', centered: true });
    modalRef.result
      .then((refresh: boolean) => {
        if (refresh) {
          this.journalTable?.refresh(true);
        }
      })
      .catch(() => {});
  }
}
